import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { usePriceRowContext } from '../../../../price-row-context';
import RatingSmiley from 'src/components/rating/smiley-rating';
import formatNumber from 'src/globals/helpers/format-number';
import * as S from './styles';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

interface IStoreReviews {
  reviewCount: number;
  storeLink: string;
}

export const StoreReviews: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IStoreReviews>
>> = props => {
  const { reviewCount, storeLink } = props;
  const { isFeatured = false, offer } = usePriceRowContext();
  const { rating } = offer;
  const { market, t } = useAppContext();

  return (
    <S.StoreReviews>
      {rating && (
        <>
          <RatingSmiley
            featured={isFeatured}
            rating={rating}
            scoreVisibility="row"
          />
          <S.Separator>|</S.Separator>
        </>
      )}
      <S.StoreLink
        to={storeLink}
        aria-label={t('reviews', 'rating.n-reviews', {
          n: reviewCount,
          count: formatNumber(reviewCount, market.code),
        })}
        data-test="StoreInfoLink"
        tabIndex={0}
        onClick={() =>
          trackInternalNavigationClick({
            scope: InternalNavigationScope.STORE_REVIEW,
            nextPage: storeLink,
          })
        }
      >
        {t('reviews', 'rating.n-reviews', {
          n: reviewCount,
          count: formatNumber(reviewCount, market.code),
        })}
      </S.StoreLink>
    </S.StoreReviews>
  );
};
